import React from "react";

const DownloadAppSection = ({ appLinks }) => (
  <div className="space-y-4 text-left">
    <p className="text-gray-500">
      La votación se realiza únicamente desde la app oficial de{" "}
      <strong className="text-brand-dark">LosHeat.TV</strong>. No se puede
      votar desde la página web.
    </p>

    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <a
        href={appLinks?.ios || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 text-center px-4 py-3 rounded-xl font-bold text-sm active:scale-95 transition-transform bg-custom-blue shadow-accent text-sky-900"
      >
        🍎 App Store
      </a>
      <a
        href={appLinks?.android || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 text-center px-4 py-3 rounded-xl font-bold text-sm active:scale-95 transition-transform bg-custom-blue shadow-accent text-sky-900"
      >
        🤖 Google Play
      </a>
    </div>
  </div>
);

export default DownloadAppSection;
